module.exports = __webpack_public_path__ + "static/media/review-image-mattis.7625d514.png";